var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "youtube_2",
    d: "M35.4 18.1501C35.1 17.1001 34.35 16.3501 33.3 16.0501C31.5 15.6001 23.85 15.6001 23.85 15.6001C23.85 15.6001 16.35 15.6001 14.4 16.0501C13.35 16.3501 12.6 17.1001 12.3 18.1501C12 20.1001 12 24.0001 12 24.0001C12 24.0001 12 27.9001 12.45 29.8501C12.75 30.9001 13.5 31.6501 14.55 31.9501C16.35 32.4001 24 32.4001 24 32.4001C24 32.4001 31.5 32.4001 33.45 31.9501C34.5 31.6501 35.25 30.9001 35.55 29.8501C36 27.9001 36 24.0001 36 24.0001C36 24.0001 36 20.1001 35.4 18.1501ZM21.6 27.6001V20.4001L27.9 24.0001L21.6 27.6001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7bccd53cfda20763660a0eda340991b7.svg";
export { ForwardRef as ReactComponent };